import { render } from "./ChartDetail.vue?vue&type=template&id=6360c769&scoped=true"
import script from "./ChartDetail.vue?vue&type=script&lang=js"
export * from "./ChartDetail.vue?vue&type=script&lang=js"

import "./ChartDetail.vue?vue&type=style&index=0&id=6360c769&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6360c769"]])

export default __exports__